<template>
    <div>
        <ul>
            <li v-for="permission in permissions">
                <input type="checkbox"
                    :value="permission.id"
                    v-model="checked">
                {{permission.name}}
            </li>
        </ul>
        <button type="button" class="btn btn-primary" @click="savePermissions()">Save</button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PermissionList',
  props: [
    'role',
  ],
  data: function () {
    return {
      checked: [],
    };
  },
  computed: {
    ...mapGetters('Identities', [
      'permissions'
    ])
  },
  methods: {
    ...mapActions('Identities', [
      'LOAD_PERMISSIONS', 'UPDATE_PERMISSIONS',
    ]),
    ...mapActions('Auth', [
      'LOAD_USER_INFO'
    ]),
    roleCan(role, permission) {
      const permissionId = permission.id;
      for (let i = 0; i < role.permissions.length; i++) {
        if (role.permissions[i].id == permissionId) return true;
      }
      return false;
    },
    savePermissions() {
      this.UPDATE_PERMISSIONS({ permissions: this.checked, id: this.role.id });
      this.LOAD_USER_INFO();
    },
    setCheckboxes() {
      this.role.permissions.forEach((permission) => {
        this.checked.push(permission.id);
      });
    }
  },
  mounted() {
    this.LOAD_PERMISSIONS();
    this.setCheckboxes();
  }
};
</script>
